module.exports = __webpack_public_path__ + "static/media/cry.f57d67e2.svg";